export const colors = {
    gold: '#a8667F',
    gris: '#9F9F9E',
    orangefonce: '#fff2e8',
    orange:'#f24f04',
    withGold:'rgb(168, 102, 127,0.4)',
  };